import React, { useState } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Checkbox, } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import { formatDate } from "../../../components/general/formateDate";
import useStyles from "./TranchesAccordionStyles";
import { convertirTimestampEnHHMM } from "../../../components/general/formatTime";

const TranchesAccordion = ({ groupedTranches, selectedTranches, handleCheckboxChange, setSelectedTranches, }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const handleSelectAll = (date) => {
    const allSelected = groupedTranches[date].every((tranche) =>
      selectedTranches.some((selected) => selected.ID === tranche.ID)
    );

    const newSelectedTranches = allSelected
      ? selectedTranches.filter((selected) => !groupedTranches[date].some((tranche) => tranche.ID === selected.ID))
      : [
        ...selectedTranches,
        ...groupedTranches[date].filter((tranche) => !selectedTranches.some((selected) => selected.ID === tranche.ID)),
      ];

    setSelectedTranches(newSelectedTranches);
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleCheckboxClick = (event) => {
    event.stopPropagation();
  };

  // Fonction pour calculer le nombre d'heures entre HeureDebut et HeureFin
  const calculateHoursPerDay = (tranches, date) => {
    let hoursPerDay = 0;
    tranches.forEach((tranche) => {
      if (tranche.DateActivite === date) {
        const hours = (tranche.HeureFin - tranche.HeureDebut);
        hoursPerDay += hours;
      }
    });
    return convertirTimestampEnHHMM(hoursPerDay);
  };

  return (
    <div>
      {Object.keys(groupedTranches).map((date, index) => (
        <Accordion
          key={index}
          className={classes.accordion}
          expanded={expanded === index}
          onChange={handleChange(index)}
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls={`panel-${index}-content`}
            id={`panel-${index}-header`}
            className={classes.accordionSummary}
          >
            <Typography variant="h6" className={classes.dateText}>
              {formatDate(date)} - Total heures :{" "} {calculateHoursPerDay(selectedTranches, date)} heures
            </Typography>
            {expanded === index && (
              <div
                className={classes.checkboxSummary}
                onClick={handleCheckboxClick}
              >
                <Checkbox
                  className={classes.checkbox}
                  checked={groupedTranches[date].every((tranche) =>
                    selectedTranches.some((selected) => selected.ID === tranche.ID)
                  )}
                  onChange={() => handleSelectAll(date)}
                />
                <Typography variant="body2" className={classes.selectAllText}>
                  Tout sélectionner
                </Typography>
              </div>
            )}
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <div className={classes.tranchesSection}>
              {groupedTranches[date].map((tranche, trancheIndex) => (
                <div key={trancheIndex} className={classes.lineItem}>
                  <Checkbox
                    checked={selectedTranches.some(
                      (selected) => selected.ID === tranche.ID
                    )}
                    onChange={() => handleCheckboxChange(tranche)}
                  />
                  {tranche.Alias}
                  <Typography
                    style={{ marginRight: 10 }}
                  >{`${tranche.NombreInscrits}/${tranche.NombreIdeal}`}</Typography>
                </div>
              ))}
            </div>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default TranchesAccordion;
